import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'merge',
  version: '1.0.0',
  properties: [
    {
      key: 'mode',
      label: 'Mode',
      type: 'options',
      required: true,
      default: 'append',
      options: [
        { value: 'append', name: 'Append' },
        { value: 'merge', name: 'Merge By Key' },
        { value: 'multiplex', name: 'Multiplex' },
      ],
      description: 'How to combine data from multiple inputs',
    },
    {
      key: 'mergeByFields',
      label: 'Merge By Fields',
      type: 'string',
      placeholder: 'id, email',
      description: 'Comma-separated list of fields to merge by',
      displayOptions: {
        show: {
          mode: ['merge'],
        },
      },
    },
    {
      key: 'clashHandling',
      label: 'Clash Handling',
      type: 'options',
      default: 'preferInput1',
      options: [
        { value: 'preferInput1', name: 'Prefer Input 1' },
        { value: 'preferInput2', name: 'Prefer Input 2' },
        { value: 'merge', name: 'Merge All' },
      ],
      description: 'How to handle conflicting values',
      displayOptions: {
        show: {
          mode: ['merge'],
        },
      },
    },
  ],
};

export default schema;
